import { Box, Icon } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CustomTooltip } from 'modules/finance/components/FinancialWorkspace/components/CustomTooltip'
import { MULTI_CURRENCY_HELP_LINK } from 'modules/finance/components/FinancialWorkspace/lib/links'

export const CurrencyToolTip = () => {
  return (
    <CustomTooltip
      link={MULTI_CURRENCY_HELP_LINK}
      label={i18n.t('finance.financial_workspace.currency.daily_rates')}
    >
      <Box position="relative" style={{ top: '-2px' }}>
        <Icon.Medium icon="info-circle-line" color="grey800" />
      </Box>
    </CustomTooltip>
  )
}
